export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5103.a8c9c018.jpg";